import React from "react";
import Typewriter from "typewriter-effect";

const DynamicTyping = (props) => {
  return (
    <Typewriter
      options={{
        strings: props.titles,
        autoStart: true,
        loop: true,
        delay: 50,
        deleteSpeed: 50
      }}
    />
  );
};

export default DynamicTyping;
